import { Episode, EpisodesLoadingState } from '../types/Episode';
import { getEpisodes } from '../services/episodesLoader';
import { useAsyncData } from './useAsyncData';

/**
 * Hook to load all episodes with loading and error states
 *
 * Usage:
 *   const { episodes, loading, error } = useEpisodes();
 */
export function useEpisodes(): EpisodesLoadingState {
  const { data, loading, error } = useAsyncData<Episode[]>(
    getEpisodes,
    [],
    {
      errorMessage: 'Failed to load episodes',
      hmrEventName: 'episodes-updated'
    }
  );

  return {
    episodes: data ?? [],
    loading,
    error
  };
}
